(function() {
  'use strict';

  function BasicFormController($translate, Form) {
    var ctrl = this;

    var buildForm = function() {
      var form = new Form();

      form.addField({
        id: 'title',
        type: 'string',
        label: $translate.instant('Announcement title'),
        required: true
      });

      form.addField({
        id: 'publishDate',
        type: 'date',
        label: $translate.instant('Publish date'),
        className: 'col-sm-4',
        required: true
      });

      form.addField({
        id: 'expireDate',
        type: 'date',
        label: $translate.instant('Expiration date'),
        className: 'col-sm-4'
      });

      form.addField({
        id: 'isDismissable',
        type: 'boolean',
        label: $translate.instant('Allow the user to dismiss the announcement manually'),
        className: 'col-sm-4'
      });

      form.addField({
        id: 'content',
        type: 'wysiwyg',
        label: $translate.instant('Announcement content')
      });

      return form;
    };

    ctrl.form = buildForm();
  }

  function BasicFormDirective() {
    return {
      scope: {
        announcement: '='
      },
      restrict: 'AE',
      templateUrl: 'app/components/announcements/directives/basic-form.html',
      controller: BasicFormController,
      controllerAs: 'ctrl'
    };
  }

  BasicFormController.$inject = [
    '$translate',
    'FormsService'


  ];

  angular.module('component.announcements')
    .directive('announcementBasicForm', BasicFormDirective);
})();
